import { useNavigate } from "react-router-dom";
import { useCurrentPlan } from "@/hooks/useCurrentPlan";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Clock, Sparkles } from "lucide-react";

export const DemoTrialBanner = () => {
  const { isDemo, demoExpiresAt, loading } = useCurrentPlan();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const fa = language === "fa";

  if (loading || !isDemo || !demoExpiresAt) return null;

  const now = new Date();
  const expires = new Date(demoExpiresAt);
  const daysLeft = Math.max(0, Math.ceil((expires.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
  const urgent = daysLeft <= 7;

  return (
    <div
      className={`flex items-center justify-between gap-3 px-4 py-2 text-sm ${
        urgent
          ? "bg-destructive/10 border-b border-destructive/20 text-destructive"
          : "bg-primary/5 border-b border-primary/10 text-foreground"
      }`}
    >
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 shrink-0" />
        <span>
          {fa
            ? `دوره آزمایشی: ${daysLeft} روز باقی‌مانده`
            : `Demo trial: ${daysLeft} day${daysLeft !== 1 ? "s" : ""} remaining`}
        </span>
      </div>
      <Button
        size="sm"
        variant={urgent ? "destructive" : "default"}
        className="gap-1.5 h-7 text-xs shrink-0"
        onClick={() => navigate("/checkout?plan=pro&cycle=monthly")}
      >
        <Sparkles className="w-3 h-3" />
        {fa ? "ارتقاء" : "Upgrade Now"}
      </Button>
    </div>
  );
};
